<template>
  <LoadingState v-if="isLoading()" :size="50" />
  <ErrorState v-else-if="isErrored()" />
  <div v-else>
    <div class="row">
      <div class="col-md-12 mb-4">
        <ElasticSearch :site="site" />
      </div>
      <div class="col-md-12 mb-4">
        <RabbitMQ :site="site" />
      </div>
      <div class="col-md-12 mb-4">
        <Solr :site="site" />
      </div>
      <div class="col-md-12 mb-4" v-if="showVarnish">
        <Card title="Varnish Caching">
          <VarnishCaching :site="site" :plan="plan" />
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import ElasticSearch from "@/components/smart/cards/ElasticSearch";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import RabbitMQ from "@/components/smart/cards/RabbitMQ";
import Solr from "@/components/smart/cards/Solr";
import store from "@/store";
import VarnishCaching from "@/components/smart/cards/VarnishCaching";

export default {
  name: "DevSiteContainersPage",
  components: { Card, ElasticSearch, RabbitMQ, Solr, LoadingState, ErrorState, VarnishCaching },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const site = computed(() => store.getters["devSites/getItem"]);
    const status = computed(() => store.getters["containers/getListStatus"]);
    const showVarnish = computed(() => site.value.app.type === "magento");

    const isErrored = () => status.value.isErrored;
    const isLoading = () => status.value.isLoading || !status.value.isInitialized;

    onMounted(() => {
      store.dispatch("containers/getList", site.value.id);
      store.dispatch("containers/getTypeList");
      store.dispatch("containers/getGroupList");
    });

    return {
      plan,
      site,
      isErrored,
      isLoading,
      showVarnish,
    };
  },
};
</script>
